import { render, staticRenderFns } from "./GuardianshipBasics.vue?vue&type=template&id=eaae3144&scoped=true"
import script from "./GuardianshipBasics.vue?vue&type=script&lang=js"
export * from "./GuardianshipBasics.vue?vue&type=script&lang=js"
import style0 from "./GuardianshipBasics.vue?vue&type=style&index=0&id=eaae3144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaae3144",
  null
  
)

export default component.exports